export default "__VITE_ASSET___FA6L_zX__"